import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import pojo from "LIB/pojos";
import { properCase } from "LIB/formatters/text";
import Section from "MODULES/shared/components/Section";
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import { SALES } from "MODULES/users/constants";
import { INVOICE_PAID_DATE } from "MODULES/SalesOrders/constants";
import ShippingAddress from "MODULES/Orders/shared/ShippingAddress";
import { hasRole } from "MODULES/users/helpers";
import {
  LINE_ITEMS,
  RECEIVED,
  RETURN_TO,
  RETURN_TO_COMPANY_ADDRESS_ID,
  RETURN_TO_COMPANY_ID,
  RETURN_TO_CUSTOMER_ADDRESS_ID,
  RETURN_TO_FOB,
  RETURN_TO_LOCATION_ID,
  RETURN_TO_SHIPPING_ADDRESS,
  RETURN_TO_SHIPPING_METHOD,
  RETURN_TO_TYPE
} from "APP_ROOT/constants";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { loadRecord } from "MODULES/shared/decorators";
import * as actions from "MODULES/SalesOrders/actions";
import Form from "./Form";

function ReturnTo({ salesOrderWithAllLineItems, currentUser }) {
  const initialValues = pojo(salesOrderWithAllLineItems.toJS()).pick(
    RETURN_TO_TYPE,
    RETURN_TO_FOB,
    RETURN_TO_COMPANY_ID,
    RETURN_TO_COMPANY_ADDRESS_ID,
    RETURN_TO_CUSTOMER_ADDRESS_ID,
    RETURN_TO_LOCATION_ID,
    RETURN_TO_SHIPPING_ADDRESS,
    RETURN_TO_SHIPPING_METHOD
  );

  const hasExchange = salesOrderWithAllLineItems.get("has_exchange");

  const userCanEditReturnToFields = hasRole(currentUser, SALES);

  const renderForm = close => (
    <Form
      close={close}
      salesOrder={salesOrderWithAllLineItems.toJS()}
      initialValues={initialValues}
      renderCarrier={!!hasExchange}
    />
  );

  if (!hasExchange) return null;

  return (
    <Section
      title={properCase(RETURN_TO)}
      modal={{
        title: "Edit Sales Order - Return To",
        content: renderForm
      }}
      editable={
        userCanEditReturnToFields &&
        !salesOrderWithAllLineItems
          .get(LINE_ITEMS)
          .some(l => l.get(RECEIVED)) &&
        !salesOrderWithAllLineItems
          .get(LINE_ITEMS)
          .some(l => l.get(INVOICE_PAID_DATE))
      }
    >
      <ShippingAddress
        shippingType={RETURN_TO}
        record={salesOrderWithAllLineItems}
        renderPreferences={!hasExchange}
      />
      <hr />
    </Section>
  );
}

ReturnTo.propTypes = {
  salesOrderWithAllLineItems: T.instanceOf(Map).isRequired,
  ...WithCurrentUser
};

export default withCurrentUser(
  withRouter(
    connect(state => ({
      salesOrderWithAllLineItems: state.salesOrderWithAllLineItemsDetail.get(
        "salesOrderWithAllLineItems"
      )
    }))(
      loadRecord({
        reducer: "salesOrderWithAllLineItemsDetail",
        name: "salesOrderWithAllLineItems",
        action: id => actions.fetchSalesOrderWithAllLineItems(id)
      })(ReturnTo)
    )
  )
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Panel/ReturnTo/ReturnTo.jsx